import { useState } from 'react'
import { ChevronDown } from 'lucide-react'

export function Accordion({
  title,
  children,
  /** Zurückhaltende Variante: kleinerer, nicht fetter Titel (z.B. für Quellen unter dem Artikel). */
  subtle = false,
}: {
  title: string
  children: React.ReactNode
  subtle?: boolean
}) {
  const [open, setOpen] = useState(false)

  return (
    <div className="rounded-lg bg-background/30">
      {/* Header */}
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between text-muted-foreground px-4 py-2 text-left"
      >
        <span className={subtle ? 'text-sm' : 'font-semibold text-md'}>{title}</span>
        <ChevronDown
          className={`w-4 h-4 shrink-0 text-primary/60 transition-transform ${open ? 'rotate-180' : ''}`}
        />
      </button>

      {/* Inhalt */}
      {open && <div className="px-4 pb-4 pt-1 text-sm text-muted-foreground prose">{children}</div>}
    </div>
  )
}
